import React from 'react';

const AdminHelpRequests = () => {
    return (
        <div className="section-padding">
            <div className="container-custom">
                <h1 className="text-3xl font-bold mb-6">Manage Help Requests</h1>
                <p className="text-gray-600">Help request management interface coming soon.</p>
            </div>
        </div>
    );
};

export default AdminHelpRequests;
